module.exports = __webpack_public_path__ + "img/tommy_3plus_100x100.9673ca0b.png";